const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-employee" */ '@/pages/financial/tariff/furniture/employee/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-employee" */ '@/pages/financial/tariff/furniture/employee/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-employee" */ '@/pages/financial/tariff/furniture/employee/edit.vue'
  )

export default {
  name: 'FinancialFurnitureEmployeeTariff',
  path: 'employee',
  meta: {
    label: 'employeeTariff',
    auth: 'employee'
  },
  component: {
    name: 'Employee',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffEmployeeReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffEmployee',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffEmployee',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
